import uniqueId from 'lodash/uniqueId';
import elementFactory from '../elements/factory';
import actionFactory from '../props/action';
import paddingModifier from '../props/padding-modifier';
import textStyle, { TEXT_STYLE } from '../props/text-style';
import textProp from '../props/text';
import { getTextWeight } from '../../util';

/**
 * Парсер блока div-footer-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-footer-block.json
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    var text = textProp(block.text);

    return {
        action: actionFactory(block),
        text: text,
        textStyle: textStyle(block.text_style, TEXT_STYLE.button),
        image: elementFactory(block.image),
        paddingModifier: paddingModifier(block),
        type: block.type,
        id: uniqueId('block_'),
        weight: getTextWeight(text)
    };
});